import React from 'react';

import { PlusIcon } from '@vlabs/icons';
import { Button } from '@vlabs/uikit/components/controls/button';
import type { ButtonProps } from '@vlabs/uikit/components/controls/button/Button';
import { useHasPermission } from '@vlabs/permissions';

import { buildTestid } from '@vlabs/monokit/shared/lib/utils';

import { useAttachUserDepartmentsTranslation } from '../i18n';
import type { AttachUserDepartmentsProps } from '../types';
import { AttachUserDepartmentsDropdown } from './AttachUserDepartmentsDropdown';

type AttachUserDepartmentButtonProps =
  AttachUserDepartmentsProps &
  Omit<ButtonProps, 'onClick'>;

const displayName = 'AttachUserDepartmentsButton';
const testid = buildTestid(displayName);

function AttachUserDepartmentsButton({
  userId,
  'data-testid': dataTestId = undefined,
  disabled = false,
  ...props
}: AttachUserDepartmentButtonProps): React.JSX.Element | null {
  const hasAccess = useHasPermission('users', 'update');
  if (!hasAccess) return null;
  const { t } = useAttachUserDepartmentsTranslation();

  return (
    <AttachUserDepartmentsDropdown
      disabled={disabled}
      userId={userId}
    >
      <Button
        icon={<PlusIcon />}
        variant="flat"
        {...testid(dataTestId)}
        {...props}
      >
        {t('title')}
      </Button>
    </AttachUserDepartmentsDropdown>
  );
}

AttachUserDepartmentsButton.displayName = displayName;

export { AttachUserDepartmentsButton };
